import { SecLoansAnalyticsService } from '@sec-loans-ui/services/analyticsService'
import { useAnalyticsService } from '@sec-loans-ui/state/analyticsContext'
import { IfpCreateApplicationRequest } from '@shared/sec-loans'
import { getOpenErrorPromptModalEvent } from '@ui-common/components/Modal'
import { usePersistingActor } from '@ui-common/hooks'
import { GlobalServicesContext } from '@ui-common/state'
import { useSelector } from '@xstate/react'
import { use } from 'react'
import { useIntl } from 'react-intl'
import { ContextFrom, StateValueFrom } from 'xstate'

import { createNewIfpApplicationMachine, NewIfpApplicationMachineType } from './newIfpApplicationMachine'

interface UseNewIfpApplicationMachineLogicReturn {
  submit: (data: IfpCreateApplicationRequest) => void
  stateValue: StateValueFrom<NewIfpApplicationMachineType>
  createdApplicationId: ContextFrom<NewIfpApplicationMachineType>['response']
  openErrorModal: () => void
  analyticsService: SecLoansAnalyticsService
}

export const useNewIfpApplicationMachineLogic = (): UseNewIfpApplicationMachineLogicReturn => {
  const intl = useIntl()
  const machine = createNewIfpApplicationMachine()
  const actor = usePersistingActor<NewIfpApplicationMachineType>(machine)
  const { analyticsService } = useAnalyticsService()
  const { modalService } = use(GlobalServicesContext)

  const openErrorModal = () => {
    analyticsService.sendModalViewEvent('ErrorPromptModal')
    modalService.send(
      getOpenErrorPromptModalEvent(() => {
        actor.send({ type: 'PROMPT_CONFIRMED' })
        analyticsService.sendModalCustomEvent('ErrorPromptModal', 'ConfirmButton')
      }, intl),
    )
  }

  const {
    value,
    context: { response },
  } = useSelector(actor, (s) => s)
  return {
    submit: (data: IfpCreateApplicationRequest) => {
      actor.send({ type: 'SUBMIT', data })
    },
    stateValue: value,
    createdApplicationId: response,
    openErrorModal,
    analyticsService,
  }
}
